import { Chart } from '@frontend/chart/types';

export const STOCK_VOLUME_BY_PRODUCT_LIST_CHART_MOCK_DATA: Chart = {
    series: [
        { name: 'Safety gloves', data: [{ label: 'full_period', value: 420 }] },
        { name: 'Ear protection', data: [{ label: 'full_period', value: 310 }] },
        { name: 'Safety glasses', data: [{ label: 'full_period', value: 265 }] },
        { name: 'Work boots', data: [{ label: 'full_period', value: 188 }] },
        { name: 'Hi-vis vest', data: [{ label: 'full_period', value: 142 }] },
        { name: 'Hard hat', data: [{ label: 'full_period', value: 97 }] },
        { name: 'Dust mask', data: [{ label: 'full_period', value: 54 }] },
        { name: 'Knee pads', data: [{ label: 'full_period', value: 21 }] }
    ]
};
